import {PortExposuresItemChunk} from "../../chunks/types/PortExposuresItemChunk";
import {getOwnPortNameFromPortExposureBodyChunk} from "./getOwnPortNameFromPortExposureBodyChunk";

export function getOwnPortNameFromPortExposuresItemChunk(
  portExposuresItemChunk: PortExposuresItemChunk
): string {
  const {
    captures: {
      1: portExposureBodyChunk
    }
  } = portExposuresItemChunk;
  return getOwnPortNameFromPortExposureBodyChunk(portExposureBodyChunk);
}
